import { render, staticRenderFns } from "./outWx.vue?vue&type=template&id=7541d790&scoped=true"
import script from "./outWx.vue?vue&type=script&lang=ts"
export * from "./outWx.vue?vue&type=script&lang=ts"
import style0 from "./outWx.vue?vue&type=style&index=0&id=7541d790&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7541d790",
  null
  
)

export default component.exports